/*!

=========================================================
* Central System - v1.0.0
=========================================================

* Coded by Aircode

=========================================================

*/
import React from "react";
import './About.css'

// reactstrap components
import {
    Button,
    Card,
    Container,
    Row,
    Col,
} from "reactstrap";

class About extends React.Component {

    render() {
        return (
            <>
                <section className="section section-lg pt-5 mt-5">
                    <Container className="learn-more">
                        <Card className="bg shadow-lg border-16 text-center">
                            <div className="p-5">
                                <Row className="align-items-center justify-content-center">
                                    <Row lg="8 justify-content-center">
                                        <h2 className="text-white">
                                            Learn about Fred S. Keller.
                                        </h2>
                                        <p className="lead text-white mt-3">
                                            The Fred S. Keller School (FSK) offers internationally 
                                            recognized behavior analytic preschool and early intervention programs 
                                            for children 18 months to 5 years old, with and without disabilities.  
                                            Learn more about FSK's programs, including early intervention and integrated preschool options.
                                        </p>
                                    </Row>
                                    <Row className="justify-content-center" lg="1">
                                        <Button
                                            
                                            className="btn-learn"
                                            target="_blank"
                                            href="https://fredskellerschool.com/"
                                            size="lg"
                                        >
                                            Learn More
                                        </Button>
                                    </Row>
                                </Row>
                            </div>
                        </Card>
                    </Container>
                </section>

            </>
        )
    }
}

export default About;